// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import axios from 'axios'

import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import JsEncrypt from 'jsencrypt'
//密码加密 RSA加密
Vue.prototype.$jsEncrypt = function(psd){
  let encry = new JsEncrypt();
  encry.setPublicKey('MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQCiquj4HR5VBtSJiKTyr18/vLaO5fJb6L/BrawFR4u+QCP3SF6SEd4pwp5Ev2R5pS34YGU00XFCejPgDfsSnRITanvv5a5wnNLFJMaz7ACxCrZjmW3z+ZppR/I19mJsaTOOopChUMJNBdvxUO13suwYad1Nhk5fmAJn0xQJgeWR/QIDAQAB');
  let data = encry.encrypt(psd);
  return data;
}
Vue.use(ElementUI)
Vue.use(axios);

Vue.config.productionTip = false
Vue.prototype.$ajax = axios;
Vue.config.productionTip = false;
window.axios = axios;

axios.defaults.baseURL = baseIp;
// 添加一个axios请求拦截器
axios.interceptors.request.use(req => {
    return req;
}, err => {
    console.error('被拦截的错误请求:', req);
    return Promise.reject(err);
});
// 添加一个axios响应拦截器
axios.interceptors.response.use(res => {
    return res;
}, err => {
    console.log('err',err);
    if (err.response.status === 400) {
        let s;
        switch (err.response.data.result) {
            case 'login_error1':
                s = '没有携带访问凭证';
                break;
            case 'login_error2':
                s = '账号已在其他地方登录';
                break;
            case 'login_error3':
                s = '登录超时, 请重新登录';
                break;
            case 'login_error4':
                s = '没有登录';
                break;
            case 'login_error5':
                s = '其他错误';
                break;
            default:
                s = '未知的400错误!';
                break;
        }
        // $confirm.alert({
        //     content: s,
        //     onOk: () => {
        //         if (/login_error1|login_error2|login_error3|login_error4/.test(err.response.data.result)) {
        //             sessionStorage.clear();
        //             window.location.reload();
        //         }
        //     }
        // });
    } else if (err.response.data.code === 401) {
      console.log("拦截401")
        $alertBox.alert({
            message: '登录已失效!',
            onConfirm () {
                sessionStorage.clear();
                localStorage.setItem('token','');
                window.location.reload();
            }
        });
    }
    return Promise.reject(err);
});

Vue.prototype.print = (obj,type) => {
    type = type || "log";
    const log = JSON.parse(JSON.stringify(obj));
    console[type](log)
   }
require('./mock.js')
/* eslint-disable no-new */
// axios.interceptors.request.use(config => {
//   // 配置token
//   // if (store.getters.token) {
//   //   config.headers['x-requested-key'] = `ZXWL${getToken()}`
//   // }
//   config.headers["Access-Control-Allow-Origin"]="*";
//   // 配置content-Type
//   config.headers['Content-Type'] = 'application/x-www-form-urlencoded'
//   // config.headers['Content-Type'] = 'application/json'

//     // elementUI的loading
//     // load = Loading.service({ fullscreen: true })
//     return config
//   }, error => {
//     return Promise.reject(error)
//   })


new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js